/* eslint-disable no-mixed-operators */
import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
// Modern imports
import Lock from "@limitless/icons/Lock";
import Typography from "@limitless/modern/data-display/typography/Typography";

const commonStyles = {
    container: {
        opacity: 0.01,
        position: "absolute",
        top: 0,
        display: "flex",
        flexDirection: "column",
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
        height: "100%"
    },
    animate: {
        opacity: 1,
        transition: "opacity 600ms"
    },
    circle: {
        transform: "rotate(-90deg)",
        transformOrigin: "50% 50%",
        transition: "stroke-dashoffset 2s"
    },
    innercontainer: {
        position: "relative",
        backgroundColor: "rgba(255, 255, 255, .92)",
        height: 150,
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        transition: "stroke-dashoffset 2s"
    }
};

const useStyles = makeStyles(theme => ({
    ...commonStyles,
    lock: {
        fontSize: "28px",
        color: theme.palette.error.dark
    },
    circle: {
        ...commonStyles.circle,
        stroke: theme.palette.primary.main
    },
    claimedBy: {
        marginTop: "16px"
    }
}));

const RADIUS = 35;
const STROKE = 3.5;

const ModernTaskListItemLock = ({ onTransitionComplete, tasklist }) => {
    const [mounted, setMounted] = React.useState(false);
    const [progress, setProgress] = React.useState(0);

    const normalizedRadius = RADIUS - STROKE * 2;
    const circumference = normalizedRadius * 2 * Math.PI;

    const strokeDashoffset = circumference - (progress / 100) * circumference;

    const classes = useStyles();

    React.useEffect(() => {
        setMounted(true);

        const interval = setInterval(() => {
            setProgress(prevProgress => {
                if (prevProgress === 100) {
                    clearInterval(interval);
                    setTimeout(() => {
                        setMounted(false);
                        onTransitionComplete();
                    }, 5000);

                    return 100;
                }

                return Math.min(prevProgress + 1, 100);
            });
        }, 10);

        return () => clearInterval(interval);
    }, []);

    return (
        <span className={`${classes.container} ${mounted ? classes.animate : ""}`}>
            <span className={classes.innercontainer}>
                <Lock className={classes.lock} />
                <Typography variant="button" className={classes.claimedBy}>
                    {" "}
                    {"This task has been claimed by another user"}{" "}
                </Typography>
            </span>
        </span>
    );
};

ModernTaskListItemLock.propTypes = {
    onTransitionComplete: PropTypes.func,
    tasklist: PropTypes.object
};

export default ModernTaskListItemLock;
